// extracted by mini-css-extract-plugin
export default {"panel":"EEpRbEUXaxeGfIE11AMc","panelHeader":"n78RUHdkpMLbS7y3SbH2"};